import { PropsWithChildren, useCallback, useMemo, useState } from 'react';
import { createSafeContext } from '@mews/framework';
import { RateGroupOverview } from '@mews-commander/data-access';
import { RateGroupTabValues } from '../../types';
import { RateGroupSidePanel } from './RateGroupSidePanel';

interface OpenParams {
    rateGroup: RateGroupOverview;
    tab: RateGroupTabValues;
}
interface SidePanelContextValue {
    open: (params: OpenParams) => void;
    close: () => void;
}

const { RateGroupSidePanelContextProvider: ContextProvider, useRateGroupSidePanelContext } = createSafeContext<
    'RateGroupSidePanelContext',
    SidePanelContextValue
>('RateGroupSidePanelContext');

export const RateGroupSidePanelContextProvider = ({ children }: PropsWithChildren<{}>) => {
    const [initialTab, setInitialTab] = useState<RateGroupTabValues>();
    const [selectedRateGroup, setSelectedRateGroup] = useState<RateGroupOverview>();

    const closeSidePanel = useCallback(() => {
        setInitialTab('general');
        setSelectedRateGroup(undefined);
    }, []);

    const contextValue = useMemo(
        () => ({
            open: ({ rateGroup, tab }: OpenParams) => {
                setInitialTab(tab);
                setSelectedRateGroup(rateGroup);
            },
            close: closeSidePanel,
        }),
        [closeSidePanel]
    );

    return (
        <ContextProvider value={contextValue}>
            {children}
            <RateGroupSidePanel
                initialTab={initialTab}
                handleCloseSidePanel={closeSidePanel}
                rateGroup={selectedRateGroup}
            />
        </ContextProvider>
    );
};

export { useRateGroupSidePanelContext };
